import Cookies from 'js-cookie'

import {fetchList} from '@/api/shoppingCart'
// import {PointscartList} from '@/api/integralShop'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get('sidebarStatus'),
      withoutAnimation: false
    },
    device: 'desktop',
	count: 0,
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
      state.sidebar.opened = !state.sidebar.opened
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },

  },
  actions: {
    ToggleSideBar: ({ commit }) => {
      commit('TOGGLE_SIDEBAR')
    },
    CloseSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    ToggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },

	async changeCount({ commit, state }){
		const res = await fetchList();
		// const point = await PointscartList();
		let total = 0;
		try {
			switch (res.status) {
				case 200:
					total = res.data.data.length;
					break;
			}
			// switch (point.status) {
			// 	case 200:
			// 	  if(point.data.data.data){
   //          total += point.data.data.data.length;
   //        }
			// 		break;
			// }
			state.count = total;
			return total;
		} catch (e) {
			console.log(e);
		}
	}
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js